import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowRoundDown, IoMdArrowRoundUp } from "react-icons/io";
import { FiPlus, FiSearch, FiEdit2 } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { BsThreeDotsVertical } from "react-icons/bs";
import { GoFilter } from "react-icons/go";
import {
  useGetAllProductsQuery,
  useDeleteProductMutation,
} from "../redux/services/products";
import { useGetAllCategoriesQuery } from "../redux/services/categories";
import { useGetAllProductTypeQuery } from "../redux/services/product_type";
import toggleOn from "../assets/icons/toggle-on-icon.svg";
import toggleOff from "../assets/icons/toggle-off-icon.svg";
import Pagination from "../components/pagination";
import { createClient } from "../utils/supbase/client";
import DeleteProductModal from "./admin-delete-product-modal";
import Loader from "../components/Loader";

const ProductListingTable = () => {
  const supabase = createClient();
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchQuery, setSearchQuery] = useState("");
  const [modal, setModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const pageLimit = 10;
  const offset = (pageNumber - 1) * pageLimit;
  const [totalItems, setTotalItems] = useState();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();

  const {
    data: allProducts,
    refetch,
    isLoading: gettingallProducts,
  } = useGetAllProductsQuery({
    offset: offset,
    pageLimit: pageLimit,
  });
  const [deleteProduct] = useDeleteProductMutation();

  const { data: categories } = useGetAllCategoriesQuery();

  const { data: product_type } = useGetAllProductTypeQuery();

  useEffect(() => {
    const getTotalProducts = async () => {
      const { data: countData, error: countError } = await supabase.rpc(
        "products_count"
      );

      if (countError) {
        throw countError;
      } else if (countData) {
        setTotalItems(countData);
      }
    };

    getTotalProducts();
  }, []);

  const toggleSortOrder = () => {
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const handleSearch = (e) => setSearchQuery(e.target.value.toLowerCase());

  const filteredProducts =
    allProducts?.filter((product) =>
      product?.title.toLowerCase().includes(searchQuery)
    ) || [];

  const sortedProducts = filteredProducts.sort((a, b) => {
    if (sortOrder === "asc") {
      return a.title.localeCompare(b.title);
    }
    return b.title.localeCompare(a.title);
  });

  const getCategoryTitle = (categoryId) => {
    const category = categories?.find((cat) => cat.id === categoryId);
    return category ? category.title : "Unknown Category";
  };
  const getProductType = (productTypeId) => {
    const productType = product_type?.find(
      (product) => product.id === productTypeId
    );
    return productType ? productType?.name : "Unknown Product Type";
  };

  // const stockToggle = (quantity) => {
  //   return quantity > 0 ? (
  //     <img src={toggleOn} alt="toggleOn" />
  //   ) : (
  //     <img src={toggleOff} alt="toggleOff" />
  //   );
  // };

  const handleDeleteClick = (product) => {
    setSelectedProduct(product);
    setModal(true);
  };

  const handleDeleteProduct = async (productId) => {
    await deleteProduct(productId);
    refetch();
    setModal(false);
  };

  const handleCloseModal = () => {
    setModal(false);
  };

  const handleEditProduct = (product) => {
    navigate("/admin/add-product", { state: { product } });
  };

  return (
    <div className="container mx-auto py-4 px-0">
      <div className="flex justify-between items-center mb-4 gap-2 overflow-hidden">
        <Link
          to="/admin/add-product"
          className="bg-[#F87315] h-[48px] text-white md:px-4 px-1 py-2 rounded-lg flex justify-center items-center text-nowrap gap-2"
        >
          <FiPlus /> Add Product
        </Link>
        <div className="flex items-center gap-2">
          <div className="relative md:w-[464px] ">
            <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#9D9EA1]" />
            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              className="border px-10 py-1 rounded-lg w-full h-[48px] bg-[#F1F3F9] placeholder-[#9D9EA1]"
              onChange={handleSearch}
            />
          </div>
          {/* <button className="bg-[#F1F3F9] h-[48px] px-4 py-2 rounded-lg text-[#484E5A] flex justify-center items-center gap-2">
            <GoFilter className="text-[#484E5A]" />
            Filter
          </button> */}
        </div>
      </div>
      <div className="md:overflow-visible md:max-h-none overflow-y-auto max-h-[400px]">
        <table className="min-w-full border-separate border border-[#F1F3F9] rounded-lg border-spacing-y-0 overflow-auto">
          <thead className="bg-[#F9FAFB]">
            <tr className=" border-b border-[#F1F3F9] text-[#484E5A] text-sm items-start">
              <th className="p-2 text-left">
                <div className="flex items-center">
                  {/* <input
                    type="checkbox"
                    className="mr-2 h-4 w-4 border border-[#D0D5DD] rounded-md appearance-none checked:bg-[#F87315] checked:border-transparent focus:outline-none"
                  /> */}
                  <span
                    className="cursor-pointer flex items-center gap-1"
                    onClick={toggleSortOrder}
                  >
                    Name{" "}
                    {sortOrder === "asc" ? (
                      <IoMdArrowRoundUp />
                    ) : (
                      <IoMdArrowRoundDown />
                    )}
                  </span>
                </div>
              </th>
              <th className="p-2 text-left">Category</th>
              {/* <th className="p-2 text-left">Stock</th> */}
              <th className="p-2 text-left">SKU</th>
              <th className="p-2 text-left">Price</th>
              <th className="p-2 text-left">Qty</th>
              <th className="p-2 text-left">Status</th>
              <th className="p-2 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {gettingallProducts ? (
              <tr>
                <td colSpan="100%">
                  <div className="flex justify-center items-center">
                    <Loader />
                  </div>
                </td>
              </tr>
            ) : filteredProducts?.length === 0 ? (
              <tr>
                <td colSpan="100%">
                  <div className="flex justify-center items-center py-4 text-gray-500">
                    No data found
                  </div>
                </td>
              </tr>
            ) : (
              sortedProducts?.map((product, index) => (
                <tr key={index} className="border-b border-[#F1F3F9] text-sm">
                  <td className="p-2 flex items-center gap-3">
                    {/* <input
                      type="checkbox"
                      className="h-4 w-4 border border-[#D0D5DD] rounded-md appearance-none checked:bg-[#F87315] checked:border-transparent focus:outline-none"
                    /> */}
                    <img
                      className="w-4 h-6 md:w-[48px] md:h-[56px] object-cover rounded-lg"
                      src={product.image_urls[0]}
                      alt=""
                    />
                    <div className="flex flex-col">
                      <span className=" text-[#101828] font-semibold">
                        {product.title}
                      </span>
                      <span className=" text-[#696D77] font-normal">
                        @{getProductType(product.product_type_id)}
                      </span>
                    </div>
                  </td>
                  <td className="p-2 text-[#696D77]">
                    {getCategoryTitle(product?.category_id)}
                  </td>
                  {/* <td className="p-2 text-[#696D77]">
                    {stockToggle(product?.stock_quantity)}
                  </td> */}
                  <td className="p-2 text-[#696D77]">{product?.sku_number}</td>
                  <td className="p-2 text-[#696D77] flex flex-col">
                    <span>$ {product?.price}</span>
                    {product?.sale_price > 0 && (
                      <span className="bg-[#F8F9FC] text-[10px] rounded-lg px-1 w-fit">
                        {product?.sale_price}% OFF
                      </span>
                    )}
                  </td>
                  <td className="p-2 text-[#696D77]">
                    {product?.stock_quantity > 0 ? product?.stock_quantity : 0}
                  </td>
                  <td className="p-2">
                    <span className="bg-[#EDFDF8] text-[12px] text-[#0EA472] rounded-lg p-1 w-fit">
                      Published
                    </span>
                  </td>
                  <td className="p-2 gap-3 flex">
                    <button
                      className="mr-2 text-[#667085]"
                      onClick={() => handleEditProduct(product)}
                    >
                      <FiEdit2 />
                    </button>
                    <button
                      className="mr-2 text-[#667085]"
                      onClick={() => handleDeleteClick(product)}
                    >
                      <RiDeleteBinLine />
                    </button>
                    {/* <button className="text-[#667085]">
                      <BsThreeDotsVertical />
                    </button> */}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={pageNumber}
        totalItems={totalItems}
        itemsPerPage={pageLimit}
        onPageChange={handlePageChange}
      />
      {modal && (
        <DeleteProductModal
          product={selectedProduct}
          onDelete={handleDeleteProduct}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default ProductListingTable;
